const BASE_URL = process.env.REACT_APP_BACKEND_URL;

// AUTH ENDPOINTS
export const endpoints = {
  SIGNUP_API: BASE_URL + "/auth/signup",
  LOGIN_API: BASE_URL + "/auth/login",
  GET_USER_API: BASE_URL + "/auth/get-user",
  GET_USER_BY_ID_API: BASE_URL + "/auth/get-user-by-id",
  EDIT_USER_API: BASE_URL + "/auth/edit-user",
  SENDOTP_API: BASE_URL + "/auth/sendotp",
  GET_ALL_STUDENT_API: BASE_URL + "/auth/get-all-students",
  GET_ALL_TEACHER_API: BASE_URL + "/auth/get-all-teachers",

  RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
  RESETPASSWORD_API: BASE_URL + "/auth/reset-password",

  REGISTER_API: BASE_URL + "/auth/register",
  ADD_USER_API: BASE_URL + "/auth/add-user",
  GET_ALL_USERS_API: BASE_URL + "/auth/get-all-user-details",
  EDIT_USER_ADMIN_API: (userId) => `${BASE_URL}/auth/edit-user/${userId}`,
  DELETE_USER_API: (userId) => `${BASE_URL}/auth/delete-user/${userId}`,

  //school admin route 
    GET_SCHOOL_USERS_API: BASE_URL + "/auth/get-school-user-details",

};

//subject apis
export const subjectEndpoints = {
  CREATE_CLASS_API: `${BASE_URL}/subject/classes`,
  // The rest will be built dynamically in the functions since they require IDs
  CLASS_BASE_API: `${BASE_URL}/subject/classes`, 
};

//curriculum request api
export const requestEndpoints = {
  CREATE_REQUEST_API: BASE_URL + "/requests",
  GET_MY_REQUESTS_API: BASE_URL + "/requests/my-requests",
  REQUEST_BASE_API: BASE_URL + "/requests", // Used for dynamic ID routes
  
  //super Admin Endpoints
  ADMIN_GET_ALL_REQUESTS_API: BASE_URL + "/requests/isSuperAdmin/all",
  ADMIN_REQUEST_BASE_API: BASE_URL + "/requests/isSuperAdmin", // Used for dynamic ID routes
};

// followup ENDPOINTS
export const followupendpoints = {
  GET_FOLLOWUP_API: BASE_URL + "/followups",
  DELETE_FOLLOWUP_API: BASE_URL + "/followups",

  GET_FOLLOWUPLC_API: BASE_URL + "/followups/lc",
  DELETE_FOLLOWUPLC_API: BASE_URL + "/followups/lc",
  // LOGIN_API: BASE_URL + "/auth/login",
  // GET_USER_API: BASE_URL + "/auth/get-user",
  // EDIT_USER_API: BASE_URL + "/auth/edit-user",
};

// CHATBOT ENDPOINTS
export const chatbotendpoints = {
  CHATBOT_API: BASE_URL + "/chatbot",
  TEACHER_CHATBOT_API: BASE_URL + "/chatbot/teacherbot",
  TEACHER_KEY_POINT_CHATBOT_API: BASE_URL + "/chatbot/teachersKeyPoints",
  TEACHER_Q_N_A_CHATBOT_API:
    BASE_URL + "/chatbot/teachersQuestionAnswerGeneration",
  CURRICULUM_BOT_API: BASE_URL + "/chatbot/CurriculmnSchoolAdmin",
  PDF_API: BASE_URL + "/chatbot/pdf",
  CHECK_USAGE_LIMIT_API: BASE_URL + "/chatbot/check-usage",
  INCREASE_USAGE_LIMIT_API: BASE_URL + "/chatbot/increase-apicount",
};

//MIDDLEWARE ENDPOINT
export const middlewareendpoints = {
  CHECK_USAGE_LIMIT_API: BASE_URL + "/middleware/checkLimit",
};

//Conversation
export const conversationendpoints = {
  CREATE_CONVERSATION_API: BASE_URL + "/conversation",

  EDIT_CONVERSATION_TITLE_API: BASE_URL + "/conversation", // append /:id,

  GET_USER_CONVERSATIONS_API: BASE_URL + "/conversation",

  GET_CONVERSATION_BY_ID_API: BASE_URL + "/conversation", // append /:id

  DELETE_CONVERSATION_API: BASE_URL + "/conversation", // append /:id
};

//Message
export const messageendpoints = {
  GET_MESSAGES_BY_CONVERSATION_ID_API: BASE_URL + "/message", // Backend route: GET /api/message/:conversationId
  ADD_MESSAGE_API: BASE_URL + "/message", // Backend route: POST /api/message/:conversationId
};

export const curriculumendpoints = {
  GET_CURRICULUM_API: BASE_URL + "/curriculum",
  GET_CURRICULUM_BY_CLASS_API: BASE_URL + "/curriculum/class",
  GET_CURRICULUM_BY_CLASS_ADMIN_API: BASE_URL + "/curriculum/class-admin",
};

export const assignmentEndpoints = {
  GET_ASSIGNMENTS_API: BASE_URL + "/assignment",
  UPDATE_ASSIGNMENT_STATUS_API: BASE_URL + "/assignment/status",
  GET_ASSIGNMENTS_BY_ID_API: BASE_URL + "/assignment/item",
  GET_ASSIGNMENTS_BY_USER_ID_API: BASE_URL + "/assignment/item/userid",
};

export const teacherAssessmentEndpoints = {
  SUBMIT_ASSESSMENT_API: BASE_URL + "/assessments/submit",
  GET_ASSESSMENTS_API: BASE_URL + "/assessments",
};

export const teacherAnalysisEndpoints = {
  GET_ALL_TEACHER_ANLYSIS_API: BASE_URL + "/teacher-anlysis",
  GET_TEACHER_ANALYSIS_API: BASE_URL + "/teacher-anlysis",
};

export const videoUplaodEndpoints = {
  POST_VIDEO_UPLOAD_API: BASE_URL + "/video/upload",
};

export const schoolEndpoints = {
  CREATE_SCHOOL_API: BASE_URL + "/school/create",
  GET_SCHOOL_BY_ID_API: BASE_URL + "/school",
  GET_SCHOOLS_API: BASE_URL + "/school/all",
  EDIT_SCHOOL_API: BASE_URL + "/school/edit",
  DELETE_SCHOOL_API: BASE_URL + "/school/delete",
  ADD_SCHOOL_ADMIN_API: BASE_URL + "/school/add-admin",
};

export const subscriptionEndpoints = {
  ACTIVATE_SUBSCRIPTION_API: BASE_URL + "/subscription/activate",
  RENEW_SUBSCRIPTION_API: BASE_URL + "/subscription/renew",
  EXPIRE_SUBSCRIPTION_API: BASE_URL + "/subscription/expire",
  GET_SUBSCRIPTION_BY_ID_API: BASE_URL + "/subscription",
};

export const dashboardEndpoints = {
  GET_DASHBOARD_STATS_API: BASE_URL + "/stats",
};

export const studentFeesEndpoints = {
  UPDATE_STUDENT_FEES_API: BASE_URL + "/fees/update",
  CREATE_STUDENT_FEES_API: BASE_URL + "/fees/create",
  GET_STUDENT_FEES_API: BASE_URL + "/fees/student",
  PAY_FEES_API: BASE_URL + "/fees/pay",
  APPLY_DISCOUNT_API: BASE_URL + "/fees/discount",
  SEND_FEES_REMINDER_API: BASE_URL + "/fees/reminder",
};

